export const gameTypes = {
  'Account Classification': 'classification',
  'Normal Balance': 'normal', 
  'Balanced Equation': 'equation',
  'The Principles': 'principles'
};